/* eslint-disable max-len */
import React from 'react';

import { Link, useParams } from 'react-router-dom';
import logoU from '../../assets/images/logo-u.png';
import imgDateSalon from '../../assets/images/dates.png';
import logoU2 from '../../assets/images/signin-logo.png';
import imgHoraires from '../../assets/images/horaires.svg';
import imgSchool from '../../assets/images/school.svg';
import styles from './confirm.module.scss';
import content, { URL_FORMATIONS } from '~/constants';
import { downloadBadge } from '~/utils';
import { useAccountBadges } from '~/hooks/account';

const ConfirmLinks = ({
  userId,
  users,
}: {
  userId: string;
  users: any[];
}) => (
  <div className={styles.links}>
    <img src={logoU2} alt="salon" />
    <div className={styles.valid}>
      <h1>
        Mon inscription a bien<br/>
        été prise en compte
      </h1>
      <button onClick={() => downloadBadge(userId)}>J&apos;imprime mon badge</button>
      {users.length > 0 && (
        <>
          {users.map((user: any) => (
            <button
              key={user._id}
              onClick={() => downloadBadge(user._id)}
            >
              Badge de {user?.profile?.firstName[0]}.{user?.profile?.lastName}
            </button>
          ))}
        </>
      )}
      <p>Retrouvez votre badge imprimable également par mail.</p>
      <h2>Les badges digitaux ne sont pas acceptés sur le salon.</h2>
    </div>
  </div>
);

const Confirm = () => {
  const { userId = '' } = useParams();
  const { data } = useAccountBadges(userId);
  const users = data?.users.filter((u:any) => u._id !== userId) || [];
  const companyType = (data as { companyType?: string } | null | undefined)?.companyType;

  return (
    <div className={styles.confirm}>
      <div className={styles.sidebar}>
        <div className={styles.header}>
          <Link to="/" className={styles.logo}>
            <img src={logoU} alt='Coopérative U' />
          </Link>
          <div className={styles.logoDates}>
            <img src={imgDateSalon} alt='Coopérative U' />
          </div>
        </div>

        <div className={styles.mobile}>
          <ConfirmLinks userId={userId} users={users} />
        </div>

        <div className={styles.infos}>
          <section className={styles.horaires}>
            <img src={imgHoraires} alt='Coopérative U' />
            <p>
              <span className={styles.label}>LES HORAIRES&nbsp;:</span><br />
              {content.day1.day} : {content.day1.hours}<br />
              {content.day2.day} : {content.day2.hours}
            </p>
            {companyType === 'fournisseur' && (
              <p className={styles.fournisseurMention}>
                *L&apos;accès au salon se fait à partir de 7H30.
              </p>
            )}
          </section>
          {companyType === 'magasin' && (
            <section>
              <a
                href={URL_FORMATIONS}
                target="_blank"
                rel="noopener noreferrer"
                className={styles.formations}
              >
                <img src={imgSchool} alt='Coopérative U' />
                S&apos;inscrire aux formations
                <br/>
                (Inscription via UniSvers)
              </a>
            </section>
          )}
        </div>
      </div>

      <div className={styles.desktop}>
        <ConfirmLinks userId={userId} users={users} />
      </div>
    </div>
  );
};

export default Confirm;
